import React, { Fragment } from 'react';
import { TextInput, required, useTranslate } from 'react-admin';

import { Role } from '~/types';

import { l } from './RoleShow';

interface Props {
  edit?: boolean;
  role?: Role;
}

const ROLE_ID_PATTERN = /^[a-zA-Z0-9._-]{3,64}$/;

const RoleForm = (props: Props) => {
  const { edit } = props;
  const translate = useTranslate();
  const validateId = (value: string): string | undefined =>
    !value || ROLE_ID_PATTERN.test(value) ? undefined : translate(l('idValidation'));
  return (
    <Fragment>
      {!edit && <TextInput source='id' label={l('id')} validate={[required(), validateId]} />}
      <TextInput source='name' label={l('name')} validate={required()} />
    </Fragment>
  );
};

export default RoleForm;
